"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteMatchingDialogModule = /** @class */ (function () {
    function DeleteMatchingDialogModule() {
    }
    return DeleteMatchingDialogModule;
}());
exports.DeleteMatchingDialogModule = DeleteMatchingDialogModule;
